var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var controllers;
    (function (controllers) {
        var CreatePdfSettingsModalController = /** @class */ (function (_super) {
            __extends(CreatePdfSettingsModalController, _super);
            function CreatePdfSettingsModalController($scope, pdfBindingService, processConfigurationService, formService, treeService, schemaPropertyService, objectSchemaService, calculationService, manageStaticDocumentService, systemLevelService, conditionService, manageCodeService, workflowBlock, processConfigId, isReadonly, close) {
                var _this = _super.call(this, $scope, close) || this;
                _this.pdfBindingService = pdfBindingService;
                _this.processConfigurationService = processConfigurationService;
                _this.formService = formService;
                _this.treeService = treeService;
                _this.schemaPropertyService = schemaPropertyService;
                _this.objectSchemaService = objectSchemaService;
                _this.calculationService = calculationService;
                _this.manageStaticDocumentService = manageStaticDocumentService;
                _this.systemLevelService = systemLevelService;
                _this.conditionService = conditionService;
                _this.manageCodeService = manageCodeService;
                _this.scope = $scope;
                _this.scope.workflowBlock = workflowBlock;
                _this.scope.isReadonly = isReadonly;
                _this.scope.processConfigId = processConfigId;
                _this.scope.addNewPdfSection = function () { return _this.addNewPdfSection(); };
                _this.scope.deleteSection = function (index) { return _this.deleteSection(index); };
                _this.scope.isSectionTypePdfBinding = function (sectionType) { return _this.isSectionTypePdfBinding(sectionType); };
                _this.scope.isSectionTypeStaticDocument = function (sectionType) { return _this.isSectionTypeStaticDocument(sectionType); };
                _this.scope.isSectionTypeUserDefinedDocument = function (sectionType) { return _this.isSectionTypeUserDefinedDocument(sectionType); };
                _this.scope.isSectionTypeFormDocument = function (sectionType) { return _this.isSectionTypeFormDocument(sectionType); };
                _this.scope.isSectionTypeProcessVariableDocument = function (sectionType) { return _this.isSectionTypeProcessVariableDocument(sectionType); };
                _this.scope.filterManagedSections = function (managedForm) { return _this.filterManagedSections(managedForm); };
                _this.processConfigId = processConfigId;
                _this.loadPdfBindings();
                _this.loadManagedDocuments();
                _this.scope.managedForms = [];
                _this.scope.managedSections = [];
                _this.scope.staticDocuments = [];
                _this.scope.onDragOver = function ($event) { return _this.onDragOverInternal($event); };
                _this.scope.onDrop = function ($event) { return _this.onDropInternal($event); };
                if (_this.scope.workflowBlock.createPdfDto.resultSchemaPropertyId) {
                    _this.schemaPropertyService
                        .getSchemaProperty(_this.scope.workflowBlock.createPdfDto.resultSchemaPropertyId).then(function (schemaProperty) { return _this.scope.schemaProperty = schemaProperty; });
                }
                calculationService.getAllCalculations(processConfigId).then(function (calculations) {
                    _this.scope.calculations = calculations;
                });
                _this.conditionService.getAllConditions(processConfigId).then(function (conditions) {
                    _this.scope.conditions = conditions;
                });
                _this.manageStaticDocumentService.getStaticDocumentsForProcessConfiguration(_this.processConfigId).then(function (documents) {
                    _this.scope.staticDocuments = _this.scope.staticDocuments.concat(documents);
                });
                _this.systemLevelService.getSystemLevelStaticDocuments().then(function (systemLevel) {
                    _this.scope.staticDocuments = _this.scope.staticDocuments.concat(systemLevel.myStaticDocuments);
                });
                _this.systemLevelService.getSystemLevelDocumentConfiguration().then(function (sysLevel) {
                    _this.scope.systemCodes = [];
                    if (sysLevel.systemDocumentConfiguration &&
                        sysLevel.systemDocumentConfiguration.documentTypeCodeGroup &&
                        sysLevel.systemDocumentConfiguration.documentTypeCodeGroup.codes) {
                        _this.scope.systemCodes = Enumerable
                            .from(sysLevel.systemDocumentConfiguration.documentTypeCodeGroup.codes)
                            .where(function (i) { return i.isActive; }).toArray();
                    }
                });
                _this.systemLevelService.getSystemLevelCodes().then(function (systemLevel) {
                    _this.scope.codeGroups = systemLevel.myCodeGroups;
                    _this.manageCodeService.getAllCodesForProcessConfiguration(_this.processConfigId).then(function (codeGroups) {
                        _this.scope.codeGroups = _this.scope.codeGroups.concat(codeGroups);
                    });
                });
                _this.formService.getFormFields(_this.scope.processConfigId, 13 /* Document */).then(function (fields) {
                    _this.scope.documentFields = fields;
                });
                _this.processConfigurationService.getById(processConfigId).then(function (processConfiguration) {
                    if (processConfiguration.processDataSchema_id) {
                        _this.objectSchemaService.getObjectSchemaExpanded(processConfiguration.processDataSchema_id).then(function (objectSchema) {
                            var topLevelDocuments = Enumerable.from(objectSchema.properties)
                                .where(function (i) { return i.propertyType === 13 /* Document */; })
                                .toArray();
                            var listDocuments = Enumerable.from(objectSchema.properties)
                                .where(function (i) { return i.typeSchema !== null; })
                                .selectMany(function (i) { return i.typeSchema.properties; })
                                .where(function (i) { return i.propertyType === 13 /* Document */; })
                                .toArray();
                            _this.scope.documentProcessDataVariables = topLevelDocuments.concat(listDocuments);
                        });
                    }
                });
                return _this;
            }
            CreatePdfSettingsModalController.prototype.addNewPdfSection = function () {
                var newSection = {
                    sectionIndex: this.scope.workflowBlock.createPdfDto.myPdfSections.length + 1
                };
                this.scope.workflowBlock.createPdfDto.myPdfSections.push(newSection);
            };
            CreatePdfSettingsModalController.prototype.deleteSection = function (index) {
                this.scope.workflowBlock.createPdfDto.myPdfSections.splice(index, 1);
            };
            CreatePdfSettingsModalController.prototype.loadPdfBindings = function () {
                var _this = this;
                if (this.processConfigId) {
                    this.pdfBindingService.getPdfBindings(this.processConfigId).then(function (pdfBindings) { return _this.scope.pdfBindings = pdfBindings; });
                }
            };
            CreatePdfSettingsModalController.prototype.loadManagedDocuments = function () {
                var _this = this;
                if (this.processConfigId) {
                    this.formService.getFormWithSection(this.processConfigId)
                        .then(function (forms) {
                        forms.forEach(function (f) {
                            var documentSections = Enumerable.from(f.myManageSections)
                                .where(function (i) { return i.manageSectionType === 3 /* Documents */; })
                                .toArray();
                            if (documentSections.length > 0) {
                                var form = {
                                    id: f.id,
                                    name: f.name,
                                    myManageSections: documentSections
                                };
                                _this.scope.managedForms.push(form);
                                if (_this.scope.workflowBlock.createPdfDto.myPdfSections.length > 0) {
                                    var pdfSection = Enumerable
                                        .from(_this.scope.workflowBlock.createPdfDto.myPdfSections)
                                        .where(function (i) { return i.form_id === form.id; })
                                        .firstOrDefault();
                                    if (pdfSection !== null) {
                                        _this.filterManagedSections(form.id);
                                    }
                                }
                            }
                        });
                    });
                }
            };
            CreatePdfSettingsModalController.prototype.filterManagedSections = function (managedForm) {
                this.scope.managedSections = Enumerable.from(this.scope.managedForms)
                    .where(function (i) { return i.id === managedForm; })
                    .first().myManageSections;
            };
            CreatePdfSettingsModalController.prototype.isSectionTypePdfBinding = function (sectionType) {
                return sectionType === 1 /* PdfBinding */;
            };
            CreatePdfSettingsModalController.prototype.isSectionTypeStaticDocument = function (sectionType) {
                return sectionType === 0 /* StaticDocument */;
            };
            CreatePdfSettingsModalController.prototype.isSectionTypeUserDefinedDocument = function (sectionType) {
                return sectionType === 2 /* UserSelectedDocuments */;
            };
            CreatePdfSettingsModalController.prototype.isSectionTypeFormDocument = function (sectionType) {
                return sectionType === 3 /* FormDocument */;
            };
            CreatePdfSettingsModalController.prototype.isSectionTypeProcessVariableDocument = function (sectionType) {
                return sectionType === 4 /* ProcessVariableDocument */;
            };
            CreatePdfSettingsModalController.prototype.onDragOverInternal = function ($event) {
                //var treeConfig = this.treeService.getTreeConfigurationItem();
            };
            CreatePdfSettingsModalController.prototype.onDropInternal = function ($event) {
                var _this = this;
                var treeConfig = this.treeService.getTreeConfigurationItem();
                this.scope.workflowBlock.createPdfDto.resultSchemaPropertyId = treeConfig.schemaPropertyId;
                this.schemaPropertyService.getSchemaProperty(treeConfig.schemaPropertyId).then(function (schemaProperty) { return _this.scope.schemaProperty = schemaProperty; });
                $event.preventDefault();
                $event.stopPropagation();
                this.treeService.clearDragValue();
            };
            return CreatePdfSettingsModalController;
        }(controllers.BaseModalController));
        controllers.CreatePdfSettingsModalController = CreatePdfSettingsModalController;
    })(controllers = warsApp.controllers || (warsApp.controllers = {}));
})(warsApp || (warsApp = {}));
warsApp.registerController("CreatePdfSettingsModalController", [
    "$scope", "pdfBindingService", "processConfigurationService", "formService", "treeService", "schemaPropertyService",
    "objectSchemaService", "calculationService", "manageStaticDocumentsService", "systemLevelService",
    "conditionService", "manageSystemCodesService", "workflowBlock", "processConfigId", "isReadonly", "close"
]);
